import { axiosSW } from "../api/axiosDefaults";

const UPDATE_TYPE = {
    1: "update",
    2: "chrge update",
};

export const fetchTickets = async (
    payLoad,
    upDate,
    {
        setIsLoadingPos,
        setResponseDataPos,
        setResultPos,
        setCurrentTicketPos,
        setCurrentCategoryPos,
        navigate,
        handleErrorPos,
        homePath,
        setIsProcessingPos,
        setRresultMount,
        setIsValidSearchPos,
        location,
        setIsProcessingChargesPos,
    }
) => {
    const checkLastItemInSearch = (data) => {
        if (
            location &&
            location.pathname === `${homePath}/tickets/result` &&
            !data?.ticket &&
            (!data?.relatedTickets || data?.relatedTickets?.length === 0) &&
            (!data?.settlements || data?.settlements?.length === 0)
        ) {
            return true;
        } else return false;
    };

    try {
        upDate === 2
            ? setIsProcessingChargesPos(true)
            : upDate === 1
            ? setIsProcessingPos(true)
            : setIsLoadingPos(true);
        // setIsLoadingPos(true)
        setResponseDataPos(null);
        setResultPos(null);

        const { data } = await axiosSW.post(
            "/Ticket/pos/GetTicketData",
            payLoad
        );

        setResponseDataPos(data);

        switch (data?.outputStatus) {
            case 1:
                if (checkLastItemInSearch(data)) {
                    navigate(`${homePath}/shopping-cart`);
                } else {
                    setResultPos(data);
                    navigate(`${homePath}/result`);
                }
                upDate === 2
                    ? setIsProcessingChargesPos(false)
                    : upDate === 1
                    ? setIsProcessingPos(false)
                    : setIsLoadingPos(false);

                return;
            case 2:
            case 5:
                if (checkLastItemInSearch(data)) {
                    navigate(`${homePath}/shopping-cart`);
                } else {
                    if (
                        !data?.ticket &&
                        (!data?.relatedTickets ||
                            data?.relatedTickets?.length === 0) &&
                        (!data?.settlements || data?.settlements?.length === 0)
                    ) {
                        setResultPos(data);
                        navigate(`${homePath}/result`);
                    } else {
                        setCurrentTicketPos(data?.relatedTickets?.[0]);
                        setCurrentCategoryPos(
                            data?.relatedTickets?.[0]?.photos[0]?.category
                        );

                        // The function is used for both fetching and updating tickets
                        // if update set to true  it will not navigate to result page again and not set these states :
                        upDate !== 1 &&
                            upDate !== 2 &&
                            navigate(`${homePath}/tickets/result`);
                        upDate !== 1 &&
                            upDate !== 2 &&
                            setIsValidSearchPos(true);

                        // first result page mount, it is set to true and on the first mount of the result page it will be set to fault
                        //and the consequent refresh will update fetch the teckets without redirecting to result page one more time
                        upDate !== 1 && upDate !== 2 && setRresultMount(true);
                    }
                }

                upDate === 2
                    ? setIsProcessingChargesPos(false)
                    : upDate === 1
                    ? setIsProcessingPos(false)
                    : setIsLoadingPos(false);
                return;
            case 3:
            case 6:
            case 7:
            case 8:
            case 9:
                if (checkLastItemInSearch(data)) {
                    navigate(`${homePath}/shopping-cart`);
                } else {
                    if (
                        !data?.ticket &&
                        (!data?.relatedTickets ||
                            data?.relatedTickets?.length === 0) &&
                        (!data?.settlements || data?.settlements?.length === 0)
                    ) {
                        setResultPos(data);
                        navigate(`${homePath}/result`);
                    } else {
                        setCurrentTicketPos(data?.relatedTickets?.[0]);
                        setCurrentCategoryPos(
                            data?.relatedTickets?.[0]?.photos[0]?.category
                        );

                        // The function is used for both fetching and updating tickets
                        // if update set to true  it will not navigate to result page again and not set these states :
                        upDate !== 1 &&
                            upDate !== 2 &&
                            navigate(`${homePath}/tickets/result`);
                        upDate !== 1 &&
                            upDate !== 2 &&
                            setIsValidSearchPos(true);

                        // first result page mount, it is set to true and on the first mount of the result page it will be set to fault
                        //and the consequent refresh will update fetch the teckets without redirecting to result page one more time
                        upDate !== 1 && upDate !== 2 && setRresultMount(true);
                    }
                }

                upDate === 2
                    ? setIsProcessingChargesPos(false)
                    : upDate === 1
                    ? setIsProcessingPos(false)
                    : setIsLoadingPos(false);
                return;
            // ----------------------------------------------------------------------------------- quick fix

            // case 9:
            //     setResultPos(data);
            //     navigate(`${homePath}/result`);
            //     upDate ? setIsProcessingPos(false) : setIsLoadingPos(false);
            //     return;

            // ----------------------------------------------------------------------------------- quick fix

            case 4:
                setCurrentTicketPos(data?.ticket);
                setCurrentCategoryPos(data?.ticket?.photos[0]?.category);

                // The function is used for both fetching and updating tickets
                // if update set to true  it will not navigate to result page again and not set these states :
                upDate !== 1 &&
                    upDate !== 2 &&
                    navigate(`${homePath}/tickets/result`);
                upDate !== 1 && upDate !== 2 && setIsValidSearchPos(true);

                // first result page mount, it is set to true and on the first mount of the result page it will be set to fault
                //and the consequent refresh will update fetch the teckets without redirecting to result page one more time
                upDate !== 1 && upDate !== 2 && setRresultMount(true);
                upDate === 2
                    ? setIsProcessingChargesPos(false)
                    : upDate === 1
                    ? setIsProcessingPos(false)
                    : setIsLoadingPos(false);

                return;

            default:
                upDate === 2
                    ? setIsProcessingChargesPos(false)
                    : upDate === 1
                    ? setIsProcessingPos(false)
                    : setIsLoadingPos(false);
                handleErrorPos({
                    error: data,
                    errorMessage: "Bad response",
                });
        }
    } catch (error) {
        upDate === 2
            ? setIsProcessingChargesPos(false)
            : upDate === 1
            ? setIsProcessingPos(false)
            : setIsLoadingPos(false);
        // setIsLoadingPos(false);

        handleErrorPos(error);
    }
};
